export enum BirthdayClassification {
    BIRTHDATE = 0,
    APPROXIMATE_AGE = 1,
    UNKNOWN = 2,
}
